import React from 'react';
export var SessionChatTextIcon = function SessionChatTextIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 28 26"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.5V21.7794L6.78286 19.0198C6.91697 18.907 7.0698 18.8186 7.23441 18.7586L7.6952 18.5907C7.85981 18.5307 8.03366 18.5 8.20887 18.5H24.5V3.5H3.5ZM1.23223 1.23223C1.70107 0.763393 2.33696 0.5 3 0.5H25C25.663 0.5 26.2989 0.763392 26.7678 1.23223C27.2366 1.70108 27.5 2.33696 27.5 3V19C27.5 19.663 27.2366 20.2989 26.7678 20.7678C26.2989 21.2366 25.663 21.5 25 21.5H8.49459L4.6087 24.7666C4.24427 25.073 3.79995 25.2689 3.32799 25.3314C2.85603 25.3938 2.37604 25.3202 1.94448 25.1192C1.51291 24.9182 1.14771 24.5982 0.891824 24.1967C0.635936 23.7952 0.5 23.329 0.5 22.853V3C0.5 2.33696 0.763393 1.70107 1.23223 1.23223Z",
    fill: "#AA9B8C"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8.5C8.5 7.67157 9.17157 7 10 7H18C18.8284 7 19.5 7.67157 19.5 8.5C19.5 9.32843 18.8284 10 18 10H10C9.17157 10 8.5 9.32843 8.5 8.5Z",
    fill: "#AA9B8C"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 13.5C8.5 12.6716 9.17157 12 10 12H18C18.8284 12 19.5 12.6716 19.5 13.5C19.5 14.3284 18.8284 15 18 15H10C9.17157 15 8.5 14.3284 8.5 13.5Z",
    fill: "#AA9B8C"
  }));
};